import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, comics } from '@/mocks/comics';

const faqPreview = [
  { q: '歪歪漫画多久更新一次？', a: '人气短篇基本每日更新，每日晚间集中上线，睡前点开就能看到新鲜内容。' },
  { q: '漫画看多了需要付费吗？', a: '歪歪漫画所有短篇日常内容均免费观看，支持随时随地碎片快看，追更无压力。' },
  { q: '支持哪些设备阅读？', a: '电脑、平板、手机全适配，通勤路上地铁里打开就能看，画面清晰不掉帧。' },
];

const testimonials = [
  { name: '摸鱼小王', role: '上班族 · 每天通勤 40 分钟', text: '下班地铁上的续命神器，一刷就停不下来，减压效果真的绝。' },
  { name: '夜猫子阿喵', role: '睡前读物爱好者', text: '睡前看两篇软软的小剧场，心情一下就放松了，睡得特别香。' },
  { name: '课间小张', role: '大学生 · 课间十分钟', text: '课间打开就是沙雕脑洞，和同桌一起笑到停不下来。' },
];

export default function Home() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 4);
  const newComics = comics.slice(0, 6);
  const picks = comics.filter((c) => c.editorPick).slice(0, 3);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* Hero */}
      <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden bg-background-100 md:min-h-[640px]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20playful%20cartoon%20background%20of%20floating%20cute%20comic%20panels%20and%20speech%20bubbles%2C%20pastel%20orange%20cream%20and%20teal%20palette%2C%20soft%20rounded%20shapes%2C%20chibi%20characters%20laughing%2C%20cheerful%20relaxing%20atmosphere%2C%20high%20quality%20webtoon%20art&width=1600&height=900&seq=hero-bg&orientation=landscape"
            alt="韩国歪歪漫画趣味插画背景"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-transparent to-background-50"></div>
        </div>

        <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-20 text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-sm font-medium text-background-50">
            <i className="ri-sparkling-2-line"></i>
            碎片时间 · 一刷就停不下来
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
            韩国歪歪漫画
            <span className="block mt-2 text-primary-500">短篇日常 · 减压快看</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-foreground-800 md:text-lg">
            摸鱼、睡前、通勤，碎片时间一刷就停不下来。热门短篇分类齐全，搞笑减压内容持续更新，点开就能找到你的轻松入口，随时随地追更。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/comics"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-8 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:w-auto"
            >
              <i className="ri-arrow-right-line"></i>
              开始追更
            </Link>
            <Link
              to="/faq"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-background-50 px-8 py-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-background-100 whitespace-nowrap sm:w-auto"
            >
              追更须知
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
            {[
              { num: '300+', label: '连载短篇' },
              { num: '每日更新', label: '轻松追更' },
              { num: '100%', label: '免费快看' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className="font-heading text-2xl text-primary-600 md:text-3xl">{s.num}</div>
                <div className="mt-1 text-xs text-foreground-700">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">热门短篇分类</h2>
            <p className="mt-2 text-sm text-foreground-700">按你的心情挑一个，点开就是轻松入口</p>
          </div>
          <Link
            to="/comics"
            className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-5 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/comics?cat=${c.id}`}
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <span>
                <span className="block font-medium text-foreground-950">{c.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-600">{c.desc}</span>
              </span>
              <i className="ri-arrow-right-s-line ml-auto text-lg text-foreground-400"></i>
            </Link>
          ))}
        </div>
      </section>

      {/* Hot comics */}
      <section className="bg-background-100/70 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">今日爆笑短篇</h2>
          </div>
          <p className="mt-2 text-sm text-foreground-700">大家正在一刷就停不下来的热门内容</p>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {hotComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}漫画封面`}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  {comic.isNew && (
                    <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                      新更
                    </span>
                  )}
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 text-xs text-foreground-600">
                    <span className="text-primary-600">{comic.categoryName}</span>
                    <span>·</span>
                    <span>{comic.updatedAt}</span>
                  </div>
                  <h3 className="mt-2 font-medium text-foreground-950">{comic.title}</h3>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{comic.views}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-heart-3-line"></i>{comic.likes}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest updates */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">每日更新 · 睡前快看</h2>
            <p className="mt-2 text-sm text-foreground-700">晚上更新一批，睡前点开轻松收尾这一天</p>
          </div>
          <Link
            to="/comics"
            className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-5 py-2 text-sm font-medium text-accent-900 transition-colors hover:bg-accent-200 whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {newComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <img
                src={comic.cover}
                alt={`${comic.title}封面`}
                className="h-24 w-28 shrink-0 rounded-xl object-cover"
              />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="text-accent-600">{comic.categoryName}</span>
                  <span>·</span>
                  <span>{comic.episode}</span>
                </div>
                <h3 className="mt-1 truncate font-medium text-foreground-950">{comic.title}</h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{comic.summary}</p>
                <div className="mt-2 text-xs text-foreground-500">{comic.updatedAt} · 约{comic.readingTime}</div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Editor picks */}
      <section className="bg-accent-500 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-accent-600">
              <i className="ri-star-fill text-lg"></i>
            </span>
            <h2 className="font-heading text-3xl text-background-50 md:text-4xl">编辑精选 · 睡前治愈</h2>
          </div>
          <p className="mt-2 text-sm text-background-50/90">编辑部私藏的几篇软萌内容，越看越安心</p>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3">
            {picks.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group overflow-hidden rounded-2xl bg-background-50 transition-all hover:-translate-y-1"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}精选封面`}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="text-xs text-accent-600">{comic.categoryName} · {comic.updatedAt}</div>
                  <h3 className="mt-2 font-medium text-foreground-950">{comic.title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{comic.summary}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <h2 className="text-center font-heading text-3xl text-foreground-950 md:text-4xl">三步开启你的轻松追更</h2>
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {[
            { icon: 'ri-compass-3-line', title: '选个分类', desc: '从日常、职场、睡前等分类里挑一个，按心情开场。' },
            { icon: 'ri-book-open-line', title: '点开就刷', desc: '短篇内容节奏快，点开就能看，碎片时间也能看完。' },
            { icon: 'ri-heart-pulse-line', title: '天天追更', desc: '每日更新提醒，睡前睡前通勤随时随地一刷到底。' },
          ].map((step, i) => (
            <div key={step.title} className="relative rounded-2xl border border-background-200 bg-background-100/70 p-6 text-center">
              <span className="absolute right-4 top-4 font-heading text-3xl text-primary-200">{i + 1}</span>
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className={`${step.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-medium text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-background-100/70 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <h2 className="text-center font-heading text-3xl text-foreground-950 md:text-4xl">大家都说一刷就停不下来</h2>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <div className="flex text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-foreground-800">“{t.text}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-600">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ preview */}
      <section className="mx-auto max-w-4xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">追更前的小疑问</h2>
          <p className="mt-2 text-sm text-foreground-700">几个常见问题，帮你更快上手</p>
        </div>
        <div className="mt-8 space-y-3">
          {faqPreview.map((f) => (
            <div key={f.q} className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <h3 className="font-medium text-foreground-950">{f.q}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{f.a}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 rounded-full bg-secondary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap"
          >
            查看全部常见问题 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* CTA */}
      <section className="relative overflow-hidden bg-primary-500 py-16 md:py-20">
        <div className="mx-auto max-w-4xl px-4 text-center">
          <h2 className="font-heading text-3xl leading-tight text-background-50 md:text-5xl">
            现在就开始你的轻松追更吧
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-50/90 md:text-base">
            免费的短篇日常合集，摸鱼、睡前、通勤随时随地都能看。热门分类齐全，点开就是轻松入口。
          </p>
          <Link
            to="/comics"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-background-50 px-9 py-3 text-sm font-medium text-primary-700 transition-transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-sparkling-2-line"></i>
            前往漫画合集
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}